"use client";
import Button from "./Button";

export default function SubscriptionPlan({
  name = null,
  description = null,
  price = null,
  salePrice = null,
  priceDescription = null,
  duration = "annualy",
  paymentText = "Purchase",
  paymentAction = null,
  selected = false,
}) {
  return (
    <div className={`subscription-plan ${selected ? "selected" : ""}`}>
      {name && <h2>{name}</h2>}
      {description && (
        <div className="subscription-plan-description">{description}</div>
      )}
      {price && (
        <bdi>
          <ins>{price}</ins>
          {salePrice && <del>{salePrice}</del>}
          {priceDescription && <div>{priceDescription}</div>}
        </bdi>
      )}
      {duration && (
        <div className="subscription-plan-price-description">
          Paid {duration}
        </div>
      )}
      {paymentAction && (
        <Button onClicked={() => paymentAction()} text={paymentText} />
      )}
    </div>
  );
}
